"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayDescription = void 0;
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
function arrayDescription(details) {
    return Object.assign({ userFacingValue: elements => elements.map(details.elementDescription.userFacingValue).join(', '), validate(value) {
            if (!Array.isArray(value)) {
                return new InvalidResult_1.default(`Not an array: ${value}`);
            }
            for (let i = 0; i < value.length; i++) {
                const element = value[i];
                const elementResult = details.elementDescription.validate(element);
                if (elementResult instanceof InvalidResult_1.default) {
                    return elementResult;
                }
            }
            return value;
        } }, details);
}
exports.arrayDescription = arrayDescription;
